<template>
  <main class="flex flex-col justify-center items-center container">
    <img src="@/assets/images/logo-login.png" alt="logo" class="w-32 mb-10" />
    <p class="text-xl font-medium" style="color: #ac4e47">
      {{ $t("screen.auth.login.pleaseEnter") }}
    </p>
    <Form
      class="flex flex-col justify-center items-center mt-4"
      @submit="onSubmit"
    >
      <div class="relative">
        <Field
          :placeholder="$t('screen.auth.login.nickname')"
          class="w-64 h-10 bg-gray-300 rounded-2xl px-4 mb-5"
          name="nickname"
          as="input"
          rules="required"
          v-model="nickname"
        />
        <ErrorMessage
          name="nickname"
          class="
            text-xs text-red-600
            absolute
            left-2
            bottom-0.5
            whitespace-nowrap
          "
        />
      </div>
      <div class="relative">
        <Field
          type="password"
          :placeholder="$t('screen.auth.login.password')"
          class="w-64 h-10 bg-gray-300 rounded-2xl px-4 mb-6"
          name="password"
          as="input"
          rules="required"
          v-model="password"
        />
        <ErrorMessage
          name="password"
          class="
            text-xs text-red-600
            absolute
            left-2
            bottom-2
            whitespace-nowrap
          "
        />
      </div>
      <button
        type="submit"
        class="w-20 h-20 rounded-full mb-6 font-medium text-white text-2xl"
        style="background-color: #ac4e47"
      >
        GO
      </button>
    </Form>
    <div
      class="px-8 py-2 rounded-2xl flex items-center mb-2"
      style="background-color: #ffe2b0"
    >
      <input type="checkbox" id="saveInfo" v-model="saveInfo" class="mr-2" />
      <label for="saveInfo" class="tracking-wide font-medium">{{
        $t("screen.auth.login.saveInfo")
      }}</label>
    </div>
    <p class="mb-10 font-medium text-sm">
      {{ $t("screen.auth.login.noCollectPersonal") }}
    </p>
    <router-link
      :to="{
        name: 'Register',
      }"
      class="px-8 py-2 rounded-2xl text-white font-medium"
      style="background-color: #a86b42"
      >{{ $t("screen.auth.login.join") }}</router-link
    >
  </main>
</template>
<script>
import { Form, Field, ErrorMessage, defineRule, configure } from "vee-validate";
import { required } from "@vee-validate/rules";
import { localize } from "@vee-validate/i18n";
import { setLocale } from "@vee-validate/i18n";
import { mapGetters } from "vuex";

defineRule("required", required);

configure({
  generateMessage: localize({
    en: {
      names: {
        nickname: "nickname",
        password: "password",
      },
      messages: {
        required: "{field} is required.",
      },
    },
    ja: {
      names: {
        nickname: "ニックネーム",
        password: "パスワード",
      },
      messages: {
        required: "{field}を入力してください。",
      },
    },
    ko: {
      names: {
        nickname: "닉네임",
        password: "패스워드",
      },
      messages: {
        required: "{field}을(를) 입력해주세요.",
      },
    },
    zh: {
      names: {
        nickname: "绰号(儿)",
        password: "密码",
      },
      messages: {
        required: "您必須輸入{field}。",
      },
    },
  }),
});
export default {
  components: { Form, Field, ErrorMessage },
  data() {
    return {
      nickname: "",
      password: "",
      saveInfo: false,
      loginInfo: null,
      vh: window.innerHeight * 0.01,
    };
  },
  computed: {
    ...mapGetters([
      "getLoginInfo",
      "isAuthenticated",
      "getRelicId",
      "getNextRoute",
    ]),
  },
  mounted() {
    window.addEventListener("resize", this.setScreenSize());
    if (this.$store.getters.getLocale) {
      setLocale(this.$store.getters.getLocale.code);
    } else {
      setLocale("ko");
    }
    if (this.getLoginInfo) {
      this.loginInfo = JSON.parse(this.getLoginInfo).loginInfo;
      this.nickname = this.loginInfo.username;
      this.password = this.loginInfo.password;
      this.saveInfo = this.loginInfo.saveInfo;
    }
  },
  methods: {
    setScreenSize() {
      document.documentElement.style.setProperty("--vh", `${this.vh}px`);
    },
    async onSubmit() {
      this.$store
        .dispatch("login", {
          loginid: this.nickname,
          password: this.password,
          saveInfo: this.saveInfo,
        })
        .then((response) => {
          if (response.status == 200) {
            console.log(this.getNextRoute);
            if (this.getRelicId) {
              if ( this.getNextRoute ) {
                this.$router.push({
                  name: this.getNextRoute,
                  params: { relicId: this.getRelicId },
                });                
              } else {
                this.$router.push({ name: 'Antiquity' });                
              }
            } else {
              if ( this.getNextRoute == "GalleryId" || this.getNextRoute == "AlbumId" || this.getNextRoute == "AntiquityId" ) {
                this.$router.push({ name: 'Antiquity' });
              } else {
                if ( this.getNextRoute ) {
                  this.$router.push({ name: 'Antiquity' });
                } else {
                  this.$router.push({ name: this.getNextRoute });
                }
              }
            }
          }
        })
        .catch((data) => {
          console.log(data);
          if (data.message) {
            alert("올바른 회원정보를 입력해주세요.");
          } else if (data.msg) {
            alert("비밀번호가 올바르지 않습니다.");
          }
        });
    },
  },
};
</script>

<style scoped>
.container {
  min-height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
}
</style>
